import axios from '../../_framework/axios/trip-dashboard-axios'

export default {
  actions: {
    /**
     * @deprecated
     */
    refreshAttachments(context) {
      context.dispatch('AttachmentsV2/fetch', {}, { root: true })
    },
    renameAttachment(context, payload) {
      if (this.getters.isOperator) {
        axios.post(`renameAttachment/${payload.id}`, { name: payload.name }).then(response => {
          if (response.status === 200) {
            context.dispatch('refreshAttachments')
          }
        })
      }
    }
  },
  getters: {
    getAttachment(state, getters) {
      return fileRefOrId => {
        let id = fileRefOrId && fileRefOrId.id ? fileRefOrId.id : fileRefOrId
        let results = getters['AttachmentsV2/forQuery']({ id })
        if (results.length) {
          return results[0]
        } else {
          return null
        }
      }
    }
  }
}
